import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByTypeAndUnit } from '../../';
import { HorizontalUsageChart } from './';
import { useDashboardCardsUsageChart, useRouterStore, useUiUnitTypeValue } from '../../../hooks';
import { UnitTypeValues, getDashboardGraphTitleByUnitType } from '../../../middleware';
import { tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CardsUsage: React.FC = observer(() => {
    const unitType = useUiUnitTypeValue() || UnitTypeValues.DATA;
    const subTitle = getDashboardGraphTitleByUnitType(unitType);
    const title = `${tP('Top Cards')} ${subTitle}`;
    const apiTypeId = `GET_USAGE_CARDS_LIST`;
    const data = useDashboardCardsUsageChart(apiTypeId, unitType);
    const routerStore = useRouterStore();

    const goToCardList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('CardList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCardList} href={`/cards`}>
            {title}
        </a>
    );

    const goToCard = (id: string): void => {
        routerStore.goTo('Card', { params: { id } });
    };

    return (
        <Catcher>
            <LoadingApiByTypeAndUnit apiTypeId={apiTypeId} unitType={unitType} />
            <div className={Styles.chart}>
                <HorizontalUsageChart
                    sourceData={data}
                    title={title}
                    unitType={unitType}
                    titleLink={titleLink()}
                    onSelectRow={goToCard}
                />
            </div>
        </Catcher>
    );
});
